import DataTable, { IDataTableProps } from "react-data-table-component";
import { L88, L96, defaultTheme } from "@adfenix/alexandria";

const customStyles = {
  table: {
    style: {
      padding: "1px",
      border: `1px solid ${L88(defaultTheme.colors.grey)}`,
      borderRadius: "6px",
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0"
    }
  },
  tableWrapper: {
    style: {
      display: "table"
    }
  },
  rows: {
    style: {
      minHeight: "72px",
      border: "none",
      borderBottomWidth: "0 !important"
    },
    denseStyle: {
      minHeight: "42px"
    },
    stripedStyle: {
      backgroundColor: L96(defaultTheme.colors.grey)
    }
  },
  expanderButton: {
    style: {
      paddingTop: "4px"
    }
  },
  headCells: {
    style: {
      minHeight: "56px",
      fontSize: "16px",
      color: defaultTheme.colors.black
    }
  },

  pagination: {
    style: {
      fontSize: "16px",
      minHeight: "56px",
      border: `1px solid ${L88(defaultTheme.colors.grey)}`,
      color: `${defaultTheme.colors.grey}`,
      borderRadius: "6px",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0"
    }
  }
};

export function Table<T>({ ...props }: IDataTableProps<T>) {
  return (
    <DataTable
      customStyles={customStyles}
      striped
      highlightOnHover
      noHeader
      paginationComponentOptions={{
        rowsPerPageText: "Rows per page:", // translate
        rangeSeparatorText: "of"
      }}
      pagination
      {...props}
    />
  );
}
